export const TIMELINE_REQUESTED = 'TIMELINE_REQUESTED';
export const TIMELINE_SUCCESS = 'TIMELINE_SUCCESS';
export const TIMELINE_FAILED = 'TIMELINE_FAILED';

export const FILTER_TIMELINE_REQUESTED = 'FILTER_TIMELINE_REQUESTED';
export const FILTER_TIMELINE_SUCCESS = 'FILTER_TIMELINE_SUCCESS';
export const FILTER_TIMELINE_FAILED = 'FILTER_TIMELINE_FAILED';
